export const initialContentState = {
    loading: false,
    error: null,
    dataContent: null,
};
